import React, {useRef} from 'react';
import IconPanelContainer from "../Containers/IconPanelContainer";
import AddButton from "../../Atoms/Buttons/AddButton";
import UserItem from "../../Molecules/Items/UserItem";
import InvitedUserModal from "../Modals/InvitedUserModal";

const UsersPanel = () => {
  const invitedUserModal = useRef()

  const handleOpenInvitedUserModal = () => {
    invitedUserModal.current.openModal()
  }
  return (
    <>
      <IconPanelContainer
        icon="settings"
        title="Usuarios en la empresa"
      >
        <div className="ed-grid rows-gap s-gap-2">
          <AddButton
            onClick={handleOpenInvitedUserModal}
            text="Agrega un usuario"
          />
          <UserItem type="OWNER"/>
          <UserItem type="GUEST"/>
        </div>
      </IconPanelContainer>
      <InvitedUserModal ref={invitedUserModal} />
    </>
  );
};

export default UsersPanel;
